export default {"src":"/_next/static/media/thick-client.7227dc60.svg","height":278,"width":349,"blurWidth":0,"blurHeight":0};